<template>
    <div  class="display-leito opaco" :id="'leito' + index" :class="status" @click="acoesLeito(index)">

        <div class="cod_enf_leito mt-1" >
            <span class="cod_enfermaria">{{dados.leitoCodigoEnfermaria}}</span>
            <span class="cod_leito">{{dados.leitoCodigo}}</span>
        </div>

        <div class="linha_divisoria"></div>

        <figure class="icone_leito">
            <div class="text-center" v-if="dados.leitoStatus == 2 && controleTempoImpedimento() == true">
                <i class="fa fa-exclamation-triangle mt-1 impedimentoLongo" aria-hidden="true" ></i>
                <span style="font-size: 9px; display: block;">+ 5 dias</span>
            </div>

            <div class="text-center" v-else-if="dados.leitoStatus == 5 && controleTempoReserva() == true">
                <i class="fa fa-clock-o mt-1 impedimentoLongo" aria-hidden="true" ></i>
                <span style="font-size: 9px; display: block;">Excedido</span>
            </div>

            <img src="/publico/img/icone_leito_uti.svg" v-else-if="verificaLeitoUTI(dados.idTipoClinico) == true">

            <img src="/publico/img/icone_leito.svg" v-else>
        </figure>

        <div class="dia-icone" v-if="unidadeSelecionada.tipo == 5 && dados.leitoStatus == 1 && controleTempoInternacao() == true">+24h</div>
        <div class="covid-icone" v-if="dados.leitoStatus == 1 && dados.covid19 == 1">C</div>

        <div v-if="dados.leitoStatus == 0" :id="'tooltip-container' + index" style="display: none;">
            <strong>{{dados.leitoNomeEnfermaria}}</strong>
            <p class="mt-1 mb-0" v-if="dados.dataHoraUltimaMovimentacao != ''"><strong>Última movimentação:</strong> {{dados.dataHoraUltimaMovimentacao}}</p>
        </div>

        <div v-if="dados.leitoStatus == 1" :id="'tooltip-container' + index" style="display: none;">
            <strong><span id="nomePaciente">{{dados.pacienteNome}}</span></strong>
            <p class="my-0">
                <strong>Sexo: </strong>{{dados.leitoSexo}}
                <strong> Idade:</strong> {{dados.pacienteIdade}}
                <strong> Nasc:</strong> {{dados.pacienteDataNascimento}}
            </p>
            <p class="my-0"><strong>Dt. Admissão:</strong> {{dados.DataHoraInternacao}}</p>
            <p class="my-0"><strong>Dt. Admissão Leito:</strong> {{dados.dataHoraInternacaoLeito}}</p>
            <p class="my-0"><strong>Enfermaria:</strong> {{dados.leitoNomeEnfermaria}}</p>
            <p class="my-0" v-if="dados.pacienteCns.length === 15"><strong>CNS:</strong> {{dados.pacienteCns}}</p>
            <p class="my-0" v-if="dados.aih"><strong>AIH:</strong> {{dados.aih[0].numeroAih}}</p>
        </div>

        <div v-if="dados.leitoStatus == 2" :id="'tooltip-container' + index" style="display: none;">         
            <p class="my-0"><strong>Data impedimento:</strong> {{dados.dataHoraImpedimento}}</p>
            <p class="my-0"><strong>Profissional:</strong> {{dados.nomeProfissionalImpedimento}}</p>
            <p class="my-0"><strong>Motivo:</strong> {{dados.motivoImpedimento}}</p>
            <p class="my-0"><strong>Previsão da liberação:</strong> {{dados.dataHoraImpedimentoPrevisao}}</p>
        </div>

        <div v-if="dados.leitoStatus == 3" :id="'tooltip-container' + index" style="display: none;">       
            <strong>{{dados.leitoNomeEnfermaria}}</strong>

            <p class="mt-1 mb-0" v-if="dados.dataHoraUltimaMovimentacao != ''"><strong>Última Movimentação:</strong> {{dados.dataHoraUltimaMovimentacao}}</p>
            <p class="my-0"><strong>FALTA REGULAR</strong></p>
        </div>

        <div v-if="dados.leitoStatus == 4" :id="'tooltip-container' + index" style="display: none;">       
            <strong>{{dados.leitoNomeEnfermaria}}</strong>

            <p class="mt-1 mb-0" v-if="dados.dataHoraUltimaMovimentacao != ''"><strong>Última Movimentação:</strong> {{dados.dataHoraUltimaMovimentacao}}</p>
            <p class="my-0"><strong>JÁ REGULADO em</strong> {{dados.dataHoraRegulacao}}</p>
            <p class="my-0"><strong>Cód. Solicitação:</strong> {{dados.codigoSolicitacao}}</p>
            <p class="my-0"><strong>Prof. Regulador:</strong> {{dados.nomeRegulador}}</p>
            <p class="my-0"><strong>Paciente Regulado:</strong> {{dados.nomePacienteRegulado}}</p>
        </div>

        <div v-if="dados.leitoStatus == 5" :id="'tooltip-container' + index" style="display: none;">       
            <strong>{{dados.leitoNomeEnfermaria}}</strong>

            <p class="my-0"><strong>Dt. Solicitação</strong> {{dados.dataHoraReservaSolicitacao}}</p>
            <p class="my-0"><strong>Reservado até:</strong> {{dados.dataHoraReserva}}</p>
            <p class="my-0"><strong>Paciente:</strong> {{dados.nomePacienteReserva}}</p>
            <p class="my-0" v-if="dados.cnsPacienteReserva.length === 15"><strong>CNS:</strong> {{dados.cnsPacienteReserva}}</p>
            <p class="my-0"><strong>Profissional:</strong> {{dados.nomeProfissionalReserva}}</p>
        </div>


    </div>
</template>

<script>
import tippy from 'tippy.js'
import 'tippy.js/themes/light-border.css'
export default {
    props: {
        dados: Object,
        index: Number
    },
    mounted() {
        this.verificaNomeSocial();
        let conteudo = document.querySelector("#tooltip-container" + this.index).innerHTML
        tippy('#leito' + this.index,
                {
                    animation: 'shift-away',
                    theme: 'azulprefeitura',
                    arrow: true,
                    content: conteudo
                }
            );  
    },
    watch: {
        dados (value) {
            let tooltip = document.querySelector('#leito' + this.index)

            setTimeout(() => {
                let conteudo = document.querySelector("#tooltip-container" + this.index).innerHTML
                tooltip._tippy.set({
                    content: conteudo,
                })
            }, 100)
        }
    },
    computed: {
        listagemFiltradaStatus () {
            // 5=livres(no clique: Impedir Leito), 6=impedidos (no clique: Liberar Leitos -SidebarRight),
            // 7=ocupados(no clique: Transferir Leito - Etapa 1), 8=livres (no clique:  Transferir Leito - Etapa 2)
            // 9=livres(no clique: Ceder Leito), 10=ocupados(no clique: Gerar AIH)
            // 11=ocupados-longap(no clique: Notifica LongaP), 12=ocupados+longap(no clique: Editar LongaP)
            return this.$store.getters['leitos/getListagemFiltradaStatus']
        },
        status () {
            if (this.dados.leitoStatus == 0) return 'livre'
            if (this.dados.leitoStatus == 1 && this.listagemFiltradaStatus == 10 && !this.dados.aih) return 'ocupadoComAih'
            if (this.dados.leitoStatus == 1) return 'ocupado'
            if (this.dados.leitoStatus == 2) return 'impedido'
            if (this.dados.leitoStatus == 3) return 'cedido'
            if (this.dados.leitoStatus == 4) return 'regulado'
            if (this.dados.leitoStatus == 5) return 'reservado'
        },
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
    },
    methods: {
        verificaNomeSocial () {
            try {
                if (this.dados.pacienteNomeSocial != null && this.dados.pacienteNomeSocial != '') {
                    document.getElementById('nomePaciente').innerText = this.dados.pacienteNomeSocial
                }
            }
            catch (e) {
                console.error(e)
            }
        },
        acoesLeito (index) {
            this.$emit('clicar', this.dados)
        },
        controleTempoImpedimento() {
            let dt = this.dados.dataHoraImpedimento
            if (dt == '' || dt == null) return false

            let data = new Date(
                parseInt(dt.substr(6,4)),
                (parseInt(dt.substr(3,2)) - 1),
                parseInt(dt.substr(0,2))
            )
            let difdias =  86400000 * 5;
            let diferenca = new Date().getTime() - data

            if (diferenca > difdias) return true
            else return false
        },
        controleTempoInternacao () {
            let dt = this.dados.DataHoraInternacao
            if (dt == '' || dt == null) return false

            let data = new Date(
                parseInt(dt.substr(6,4)),
                (parseInt(dt.substr(3,2)) - 1),
                parseInt(dt.substr(0,2)),
                parseInt(dt.substr(11,2)),
                parseInt(dt.substr(14,2))
            )

            let difdias =  86400000
            let diferenca = new Date().getTime() - data

            if (diferenca > difdias) return true
            else return false
        },
        controleTempoReserva() {
            let dt = this.dados.dataHoraReserva
            if (dt == '' || dt == null) return false

             let data = new Date(
                parseInt(dt.substr(6,4)),
                (parseInt(dt.substr(3,2)) - 1),
                parseInt(dt.substr(0,2)),
                parseInt(dt.substr(11,2)),
                parseInt(dt.substr(14,2)),
            )

            let diferenca = data.getTime() - new Date().getTime()

            if (diferenca < 0) return true
            else return false
        },
        verificaLeitoUTI(id) {
            if (
                id == 1  ||
                id == 2  ||
                id == 3  ||
                id == 4  ||
                id == 5  ||
                id == 6  ||
                id == 7  ||
                id == 29 ||
                id == 39 ||
                id == 50 ||
                id == 51 ||
                id == 52 ||
                id == 57 ||
                id == 59 ||
                id == 60) return true
                else return false
        }
    }
}
</script>

<style>
.impedimentoLongo, .reservaExcedido {
    color: #ffffd4;
    font-size: 17px;
}
</style>
